// config.js
export const GPM = "0x24beb4e98AB528146fe271ceb36fD6467FE6F606";
export const GPMA = "0x62f74375CD4733683169e1e8cb2776EbE909D275";
export const IdGLP = "0x71E6EC0c554cb2f6D44dEc161a42E9e335FddD45";
